module.exports = __webpack_public_path__ + "img/rain-and-sun.8101c2c5.svg";